import { SlotConstantsBehavior } from '@quest/murka-games-behavior-leopard';
import { DeviceDetectorBehavior } from '@quest/murka-games-behavior-leopard/dist/DeviceDetectorBehavior';
import { gameConstants } from './Constants/gameConstants';
import { DeviceDetector } from '@quest/base-core';
import { constants } from '@quest/base-core/dist/detectDeviceEnvironment/Constants';
export class DeviceDetectorGame extends DeviceDetectorBehavior {

    public getScale() {
        if (!this.gameHeight || !this.gameWidth) {
            return 1;
        }
        this.availHeight = Number(window.innerHeight);
        this.availWidth = Number(window.innerWidth);
        if (this.isDesktop) {
            this.scale = Math.min(((this.availHeight) / this.gameHeight), (this.availWidth / this.gameWidth));
        }
        else if (this.getOrientation() === SlotConstantsBehavior.LANDSCAPE) {
            this.scale = Math.min(((this.availHeight - (SlotConstantsBehavior.WrapperTopBarHeightMobileLandscape + SlotConstantsBehavior.WrapperBottomBarHeightMobileLandscape)) / this.gameHeight), (this.availWidth / this.gameWidth));
            if (SlotConstantsBehavior.LANDSCAPE_SCALE_PERCENTAGE) {
                this.scale = this.scale - (this.scale / 100 * SlotConstantsBehavior.LANDSCAPE_SCALE_PERCENTAGE);
            }
            if (this.getAspectRatiio().toFixed(2) === SlotConstantsBehavior.IPAD_ASPECT_RATIO.toFixed(2) ||
            this.getAspectRatiio().toFixed(2) === SlotConstantsBehavior.IPAD_AIR_ASPECT_RATIO.toFixed(2) ||
            this.getAspectRatiio().toFixed(2) === gameConstants.IPAD_PRO_ASPECT_RATIO.toFixed(2) 
        ) {
                SlotConstantsBehavior.VIEW_SLIDE_MOBILE = 56
            }
            else {
                SlotConstantsBehavior.VIEW_SLIDE_MOBILE = 26
            }
        }
        else {
            this.scale = Math.min(((this.availHeight) / this.gameHeight), (this.availWidth / this.gameWidth));
            if (this.getAspectRatiio().toFixed(2) === SlotConstantsBehavior.IPAD_ASPECT_RATIO.toFixed(2)) {
                SlotConstantsBehavior.ADD_IN_Y = 0;
                ingenuity.configData.IpadDevice = true;
            }
            else {
                SlotConstantsBehavior.ADD_IN_Y = 0;
                ingenuity.configData.IpadDevice = false;
            }
        }
        return this.scale;
    }

    
    public getLandcapeMaxReelScale(): number {
        let scale: number;
        if (!this.gameHeight || !this.gameWidth) {
            return 1;
        }
        this.availHeight = Number(window.innerHeight);
        this.availWidth = Number(window.innerWidth);
        if (this.getOrientation() === SlotConstantsBehavior.LANDSCAPE) {
            scale = Math.min(((this.availHeight) / gameConstants.REEL_HEIGHT), (this.availWidth / gameConstants.REEL_WIDTH));
        }
        return scale;
    }
    public getIsIpad() {
        if (this.getAspectRatiio().toFixed(2) === SlotConstantsBehavior.IPAD_ASPECT_RATIO.toFixed(2) || 
            this.getAspectRatiio().toFixed(2) === SlotConstantsBehavior.IPAD_AIR_ASPECT_RATIO.toFixed(2)||
            this.getAspectRatiio().toFixed(2) === gameConstants.IPAD_PRO_ASPECT_RATIO.toFixed(2)||
            this.getAspectRatiio().toFixed(2) === gameConstants.IPAD_MINI_ASPECT_RATIO.toFixed(2)
        ) {
            return true;
        }
        else {
            return false;
        }
    }

    public getDeviceName() {
        const { ua, blackListDevice } = this.deviceConfig;
        this.device = this.detectName().toLowerCase();
        if (this.device === constants.OS_NAMES.ANDROID) {
            if (this.UA.match(/Mobile/i)) {
                this.device = DeviceDetector.DEVICES.MOBILE_PHONE;
            }
            else {
                this.device = this.aspectRatio <= 1.6 ? DeviceDetector.DEVICES.TABLET : DeviceDetector.DEVICES.MOBILE_PHONE;
            }
        }
        else if (ua.windows && !this.device) {
            this.device = DeviceDetector.DEVICES.DESKTOP;
        }
        else if (ua.macos) {
            if (this.AV.match(/Macintosh/i)) {
                if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
                    this.device = DeviceDetector.DEVICE_NAMES.IPAD as string;
                }
                else if (navigator.platform === "iphone" && navigator.maxTouchPoints > 1) {
                    this.device = DeviceDetector.DEVICE_NAMES.IPHONE as string;;
                }
                else {
                    this.device = DeviceDetector.DEVICES.DESKTOP;
                }
            }
        }
        else if (ua.linux && !this.device && !(this.UA.match(/Mobile/i) || this.UA.match(/android/i))) {
            this.device = DeviceDetector.DEVICES.DESKTOP;
        }
        else if (!this.device) {
            this.device = DeviceDetector.DEVICES.UNKNOWN_DEVICE;
        }
        if (this.device === DeviceDetector.DEVICE_NAMES.IPHONE) {
            var model = "" + DeviceDetector.DEVICE_NAMES.IPHONE;
            model = (window.matchMedia("(-webkit-min-device-pixel-ratio: 2)").matches && window.screen.width === 320 && window.screen.height === 480) ? DeviceDetector.DEVICE_NAMES.IPHONE + "_4|4s" : model;
            model = (window.screen.width === 320 && window.screen.height === 568) ? DeviceDetector.DEVICE_NAMES.IPHONE + "_5|5s|5c|se" : model;
            model = (window.screen.height === 667) ? DeviceDetector.DEVICE_NAMES.IPHONE + "_6|7|8" : model;
            model = window.matchMedia("(-webkit-min-device-pixel-ratio: 3)").matches ? DeviceDetector.DEVICE_NAMES.IPHONE + "_6+|7+|8+" : model;
            model = (this.minSide === 1125 && this.maxSide === 2436) ? DeviceDetector.DEVICE_NAMES.IPHONE + "_x" : model;
            this.device = model;
        }
        if (this.device === DeviceDetector.DEVICE_NAMES.IPAD) {
            this.device = (this.minSide === 2048 && this.maxSide === 2732) ? "ipad_pro" : this.device;
        }
        if (blackListDevice) {
            this.device = DeviceDetector.DEVICES.UNSUPPORTED_DEVICE;
        }
        return this.device;
    }
}